<template>

  <el-dialog :visible="true" title="轮播图配置" @close="handleCloseDialog" append-to-body :close-on-click-modal="false">
      <file-selector v-if="showFileSelector" @finish="onAddFile" fileType="image"/>

      
        <el-form label-position="left" label-width="80px">
            <el-form-item label="轮播图">
                <div style="display:flex;flex-wrap:wrap;">
            <div v-for="(item, index) in tempValue"  :key="index">
                <el-image style="width: 100px; height: 100px;margin: 10px;" :src="item.url" fit="fit"></el-image>

                <div style="display: flex;justify-content: space-around;">
                    <el-link icon="el-icon-back" @click="itemOpr('up', index)"></el-link>
                    <el-link icon="el-icon-delete" @click="itemOpr('delete', index)"></el-link>
                    <el-link icon="el-icon-right" @click="itemOpr('down', index)"></el-link>
                </div>

            </div>

            <div style=" border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;margin: 10px;   width: 100px;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;font-size: 28px;
            color: #8c939d;" @click="showFileSelector = true">
            <i class="el-icon-plus avatar-uploader-icon"></i></div>
                </div>
            </el-form-item>

            <el-form-item label="展示时长">
                <el-input v-model="tempInterval" style="width: 350px;">
                    <template slot="prepend">每张图展示</template>
                    <template slot="append">秒后轮播下一张</template>
                </el-input>
            </el-form-item>

            <el-form-item label="切换动画">
                <el-select v-model="tempTransition" @change="displayFlux">
                    <el-option value="slide" label="左右翻页"></el-option>
                    <el-option value="turn" label="翻书效果"></el-option>
                    <el-option value="blinds" label="百叶窗"></el-option>
                    <el-option value="blocks" label="块状百叶窗"></el-option>
                    <el-option value="blocks2" label="块状擦除"></el-option>
                    <el-option value="explode" label="块状飞出"></el-option>
                    <el-option value="zip" label="条块上下飞出"></el-option>
                    <el-option value="bars" label="条块下落"></el-option>

                    <!-- <el-option :value="null" label="随机"></el-option> -->

                    <!--翻转屏幕时有问题 <el-option value="concentric" label="concentric"></el-option> -->
                    <!-- 翻转屏幕时有问题 <el-option value="warp" label="warp"></el-option> -->
                    
                    <!-- 先不启用这几个吧
                    <el-option value="blinds3d" label="3D百叶窗"></el-option>
                    <el-option value="bars3d" label="bars3d"></el-option>
                    <el-option value="cube" label="cube"></el-option>
                    <el-option value="tiles3d" label="tiles3d"></el-option>
                    <el-option value="dissolve" label="dissolve"></el-option> -->

                </el-select>
            </el-form-item>

            <el-form-item>
                <div id="slideIdxxx" style="width:400px;height:300px;overflow:hidden;">
                    <!-- <el-image style="width:400px;height:300px;" fit="cover" src="https://www.joelambert.co.uk/flux/img/avatar.jpg" /> -->
                    <img object-fit="cover" :src="flux1" />
                    <img object-fit="cover" :src="flux2" />
                    <img object-fit="cover" :src="flux3" />
                </div>
            </el-form-item>
        </el-form>

     
       
       <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="onFinish()">确定</el-button>
        </span>
  </el-dialog>

</template>

<script>
    import flux1 from "@client/common/images/flux1.jpg"
    import flux2 from "@client/common/images/flux2.jpg"
    import flux3 from "@client/common/images/flux3.jpg"

    import "@client/plugins/image-carousel/src/jquery-1.7.2.min.js"
	import "@client/plugins/image-carousel/src/flux"

	import imageSelect from '@client/components/image-select'
    import { mapState, mapGetters } from 'vuex'
    import fileSelector from "@client/components/file-selector";
    import FileSelector from '../../../../../../components/file-selector.vue';




	export default {
		name: "attr-qk-image-carousel",
		props: {
			imageSrcList: {
				type: Array,
                default: () => []
            },
            interval: {
                type: Number | String,
                default: 15
            },
            transition: {
                type: String | Object,
                default: null
            }
		},
        mounted() {
            this.tempInterval = this.interval / 1000;
            this.tempTransition = this.transition;

                     
        },
		components: {
			imageSelect,
            FileSelector,
		},
          computed: {
            ...mapState({
            editActiveElement: state => state.editor.editActiveElement
            }),
            ...mapGetters([
                'activePage'
            ]),
        },
		data() {
			return {
                flux1: null,
                flux2: null,
                flux3: null,
                flux: null,
				tempValue: [],
                tempInterval: 15,
                tempTransition: null,
                showFileSelector: false
			}
		},
		created() {
            this.flux1 = flux1
            this.flux2 = flux2
            this.flux3 = flux3
            
			this.initData()

            this.$nextTick(function() {
                this.displayFlux()
            });

		},
        beforeDestroy() {
            this.flux.stop()
            this.flux = null
        },
		methods: {
            displayFlux() {
               // return;
                if (this.flux) {
                    this.flux.stop()
                    this.flux.options.transitions = [this.tempTransition];
                    this.flux.start()
                    return;
                }

                let options = {
                    pagination: false,
                    width: 400,
                    height: 250,
                    delay: 1500
                }

                if (this.tempTransition) {
                    options.transitions = [this.tempTransition];
                }

                this.flux = new flux.slider('#slideIdxxx' , options);
            },
            itemOpr(opr, index) {

                if (opr === 'up') {
                   if (index > 0) {
                        const deleteArr = this.tempValue.splice(index, 1);
                        this.tempValue.splice(index - 1, 0, ...deleteArr)
                    }
                } else if (opr === 'down'){
                    if (index < this.tempValue.length - 1) {
                        const deleteArr = this.tempValue.splice(index + 1, 1);
                        this.tempValue.splice(index, 0, ...deleteArr)
                    }

                } else if (opr === 'delete'){
                    this.tempValue.splice(index, 1);
                }
            },
            onAddFile(file) {
                this.showFileSelector = false;
                if (file) {
                    this.tempValue.push({url: file.file_url});
                }
            },
            onFinish() {
                let findResult = this.activePage.elements.some(element => {
                    if (element.uuid === this.editActiveElement.uuid) {
                        element.propsValue.imageSrcList = this.getResultImageSrcList();
                        element.propsValue.interval = this.tempInterval * 1000;
                        element.propsValue.transition = this.tempTransition
                        return true;
                    }

                    return false;
                });

                if (!findResult) {
                    let newEle = _.cloneDeep(this.editActiveElement);
                    newEle.propsValue.imageSrcList = this.getResultImageSrcList();
                    newEle.propsValue.interval = this.tempInterval * 1000;
                    newEle.propsValue.transition = this.tempTransition;

                    this.activePage.elements.push(newEle);
                }

                this.$store.commit('addHistoryCache')

                this.handleCloseDialog();
            },
            handleCloseDialog() {
            this.$store.dispatch('editActiveElement', null);
            },
			initData() {
				let list = [];
				this.imageSrcList.forEach(item => {
					list.push({url: item})
				})
				this.tempValue = list;
			},
			getResultImageSrcList() {
				let list = [];
				for (let i = 0, len = this.tempValue.length; i < len; i++) {
					list.push(this.tempValue[i].url)
				}
				return list
			}
		}
	}
</script>

<style scoped>

</style>
